module.exports = __webpack_public_path__ + "img/leakalert_blink_red.021eb54a.jpg";